import React from 'react';
import { Settings } from 'lucide-react';
import Tooltip from '../common/Tooltip';

const Header = ({ onSettingsClick }) => {
  return (
    <header className="hidden md:block bg-white/80 backdrop-blur-md border-b border-neutral-100 sticky top-0 z-30">
      <div className="container mx-auto px-6 lg:px-8 max-w-6xl">
        <div className="flex justify-between items-center h-16">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 rounded-lg flex items-center justify-center">
              <img src="logo.png" alt="Logo" />
            </div>
            <h1 className="text-lg font-bold text-neutral-800 tracking-tight">
              {process.env.REACT_APP_APP_NAME || 'Konto'}
            </h1>
          </div>
          <Tooltip content="Einstellungen" position="bottom">
            <button
              onClick={onSettingsClick}
              className="p-2 text-neutral-400 rounded-lg hover:bg-neutral-100 hover:text-neutral-700 transition-all"
            >
              <Settings size={20} />
            </button>
          </Tooltip>
        </div>
      </div>
    </header>
  );
};

export default Header;
